import { BasePerimeter } from '../perimeters'

export default new BasePerimeter({
  purpose: 'user',
  can: {
    read() {
      return this.isAuthenticated()
    },
    create() {
      return this.hasPermission('user:create')
    },
    update() {
      return this.hasPermission('user:update')
    },
    manage() {
      return this.hasPermission('user:manage')
    },
    administrate() {
      return this.isAdmin()
    }
  }
})
